import { formatTimestampHuman, formatDateHuman, formatCurrency } from "../date-utils";
export const companyInvoiceDtoFields = [{
        name: "urlPdf",
        title: "PDF",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.invoice.urlPdf != null && record.invoice.urlPdf != "" ? `<span class="icon"><i class="material-icons icon-base has-text-success">check</i></span>` : ``)
    }, {
        name: "sendEmail",
        title: "Email inviata",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.invoiceEmails == null || record.invoiceEmails.length == 0)
                return "";
            else {
                for (var i = 0; i < record.invoiceEmails.length; i++) {
                    var em = record.invoiceEmails[i];
                    if (em.risultato == "ACCODATO") {
                        return `<span class="icon"><i class="material-icons icon-base has-text-primary">access_time</i></span>`;
                    }
                }
                for (var i = 0; i < record.invoiceEmails.length; i++) {
                    var em = record.invoiceEmails[i];
                    if (em.risultato == "OK") {
                        return `<span class="icon"><i class="material-icons icon-base has-text-success">check</i></span>`;
                    }
                }
                return `<span class="icon"><i class="material-icons icon-base has-text-danger">warning</i></span>`;
            }
        }
    }, {
        name: "numeroFattura",
        title: "N° fattura",
        render: (record) => record.invoice.numeroFattura
    }, {
        name: "ownership",
        title: "Az. proprietaria",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.ownership.name
    }, {
        name: "importoPagato",
        title: "Saldata",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.invoice.importoPagato ? 'Si' : 'No') //new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits: 2})
        //.format(record.invoice.importo)
    }, {
        name: "importo",
        title: "Importo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatCurrency(record.invoice.importo) //new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits: 2})
        //.format(record.invoice.importo)
    }, {
        name: "dataEmissione",
        title: "Data Emissione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.invoice.dataEmissione)
    }, {
        name: "dataScadenza",
        title: "Data Scadenza",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.invoice.dataScadenza)
    }, {
        name: "dataPagamento",
        title: "Data Pagamento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.invoice.dataPagamento)
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.invoice.updatedOn)
    }];
